﻿package com.milta.core.localization.translations.en

import com.milta.core.localization.ProfileStrings

internal val Profile = ProfileStrings(
    screenTitle = "My profile",
    sectionPersonal = "Personal information",
    labelFirstName = "First name",
    labelLastName = "Last name",
    labelRole = "Role",
    sectionLanguage = "Language",
    labelLanguage = "App language",
    changeLanguageButton = "Change language",
    languageDialogTitle = "Choose your language",
    languageDialogConfirm = "Confirm",
    languageDialogCancel = "Cancel",
    sectionPassword = "Security",
    labelCurrentPassword = "Current password",
    labelNewPassword = "New password",
    changePasswordButton = "Change password",
    successLanguageUpdated = "Language updated successfully",
    successPasswordChanged = "Password changed successfully",
    errorProfileNotFound = "Profile not found",
    errorCurrentPasswordRequired = "Please enter your current password",
    errorCurrentPasswordTooLong = "Current password cannot exceed 128 characters",
    errorNewPasswordRequired = "Please enter a new password",
    errorNewPasswordTooShort = "New password must be at least 8 characters",
    errorNewPasswordTooLong = "New password cannot exceed 128 characters",
    errorLanguageRequired = "Please select a language",
    errorForbidden = "You are not authorised to perform this action",
    errorValidation = "The provided data is invalid",
    errorGeneric = "An error occurred. Please try again.",
    signOut = "Sign out",
    deleteAccount = "Delete my account",
    menuLanguage = "Interface language",
    menuPassword = "Change password",
    menuSubscription = "My subscription",
    menuPrivacy = "Privacy & GDPR",
    linkedCodeLabel = "Unique linking code",
    copyCode = "Copy",
    codeCopied = "Copied!",
    modeOrganisation = "Enterprise",
    modeDriver = "Driver",
    roleDriver = "Driver",
    roleOrganisation = "Enterprise",
    modeSwitchTitle = "Switch mode",
    modeSwitchHint = "Switch between Enterprise mode and Driver mode at any time",
    switchToEnterprise = "Enterprise mode",
    switchToDriver = "Driver mode",
    menuPhone = "Phone number",
    phoneOtpStepTitle = "Verification code sent by SMS",
    successPhoneUpdated = "Phone number updated",
    deleteAccountDialogTitle = "Delete your account?",
    deleteAccountDialogMessage = "This action cannot be undone. Your personal information will be deleted. A verification code will be sent by SMS to confirm.",
    deleteAccountDialogConfirm = "Continue",
    deleteAccountOtpStepTitle = "Verification code sent by SMS",
    deleteAccountConfirmButton = "Delete permanently",
    errorLastEnterpriseOwner = "You are the only manager of your enterprise. Add another Enterprise account before deleting yours.",
    logoutPendingWarningTitle = "Unsent deliveries",
    logoutPendingWarningMessageSuffix = "pending delivery(ies) will be lost if you sign out now.",
    logoutPendingWarningConfirm = "Sign out anyway",
    logoutPendingWarningCancel = "Cancel",
    modeSwitchActiveRouteWarningTitle = "Route in progress",
    modeSwitchActiveRouteWarningMessage = "A route is currently in progress. Switching mode will take you away from tracking it. Continue?",
    modeSwitchActiveRouteWarningConfirm = "Switch anyway",
    modeSwitchActiveRouteWarningCancel = "Cancel",
)

